import { styled } from '@mui/material';

import { Typography, Card, Tooltip } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { InfoCircleIcon } from '@app-velocity/icons';

import { Item } from './Item';

const StyledCard = styled(Card)({
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'space-between',
  padding: 0,
  overflow: 'hidden',
});

const Title = styled(Typography)({
  color: 'var(--text-text-tertiary-color)',
  fontWeight: 400,
  flex: 1,
});

const About = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(2.5)} ${theme.spacing(3)}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
  svg: {
    fill: 'var(--icon-icon-secondary-color)',
  },
}));

const Items = styled('div')(({ theme }) => ({
  justifyContent: 'flex-end',
  alignItems: 'center',
  display: 'flex',
  cursor: 'pointer',
}));

export const InteractiveProbabilityLegend = () => {
  const { t } = useI18n();

  return (
    <StyledCard>
      <Items>
        <Item type="high" />
        <Item type="medium" />
        <Item type="low" />
      </Items>
      <About>
        <Title variant="subtitle2">
          {t('prototypes:interactive_probability.title')}
        </Title>
        <Tooltip title={t('prototypes:confidence_score.tooltip')}>
          <InfoCircleIcon />
        </Tooltip>
      </About>
    </StyledCard>
  );
};
